import { ChangeEvent, CSSProperties, ReactNode, SyntheticEvent } from 'react';
import {
  Checkbox as MUICheckBox,
  CheckboxProps as MUICheckboxProps,
  FormControlLabel as MUIFormControlLabel,
} from '@mui/material';

import fonts from '@atom/styles/fonts';

type CustomProps = {
  /**
   * optional checkbox label
   */
  label?: ReactNode;
};

type AtomMUIProps = {
  color?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
    | 'default';
  checked?: boolean;
  onClick?: (event: SyntheticEvent<any>) => void;
  disabled?: boolean;
  edge?: false | 'end' | 'start';
  checkedIcon?: ReactNode;
  onChange?: (event: ChangeEvent) => void;
  style?: CSSProperties;
};

export type CheckboxProps = CustomProps & AtomMUIProps;

export const Checkbox = (props: CheckboxProps) => {
  const { color = 'primary', label = '', checked = false, ...data } = props;

  const MUIProps: MUICheckboxProps = data;

  return label ? (
    <MUIFormControlLabel
      label={label}
      control={<MUICheckBox color={color} checked={checked} {...MUIProps} />}
      slotProps={{ typography: { sx: { fontSize: fonts.md } } }}
    />
  ) : (
    <MUICheckBox color={color} checked={checked} {...MUIProps} />
  );
};
